"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperText = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const HelperText = ({ children, className }) => (react_1.default.createElement("span", { className: carabiners_1.joinStr(styles_scss_1.default.helper, className) }, children));
exports.HelperText = HelperText;
exports.HelperText.defaultProps = {
    className: undefined,
};
